module.exports = __webpack_public_path__ + "img/tutorial_main_05.62653be3.png";